ui-cms-infinity {
  display: block;

  .hidden {
    visibility: hidden;
  }

  .infinity__mediaSticky {
    width: 100vw;
    height: 100vh;
    position: sticky;
    top: 0;
    margin-left: -15px;
    overflow: hidden;

    picture,
    video {
      width: 100%;
      height: 100%;
    }

    @include breakpoint($medium) {
      margin-left: -30px;
    }

    @include breakpoint($desktop) {
      margin-left: -35px;
    }

    @include breakpoint($xlarge) {
      margin-left: calc((100vw - 1200px) / 2 * -1);
    }

    &--primary::before {
      background-color: $sd-backgroundColor-primary-800;
    }

    &--white::before {
      background-color: $sd-backgroundColor-white;
    }
  }

  .infinity__media {
    position: absolute;
    left: 50%;
    width: 100vw;
    height: 100vh;
    transform: translateX(-50%);
  }

  ui-cms-container {
    position: relative;
  }

  // Blur and opacity effect can't be applied on one element, so we need to use two pseudo elements
  // otherwise the opacity will affect the blur effect
  .blur {
    &::before {
      animation: opacity 2s forwards;
      content: '';
      position: absolute;
      inset: 0;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      animation: blur 2s forwards;
    }
  }

  img,
  video {
    width: 100%;
    height: 100%;
  }

  picture,
  img,
  video {
    display: block;
    object-fit: cover;
  }

  .sd-container {
    background-color: transparent;
  }

  @keyframes blur {
    0% {
      backdrop-filter: blur(0);
    }

    100% {
      backdrop-filter: blur(12px);
    }
  }

  @keyframes opacity {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 0.8;
    }
  }
}
